import LedgerTransactionTypeDao from '@/interfaces/common/LedgerTransactionType.dao'
import MarketplaceProductDao from '@/interfaces/common/MarketplaceProduct.dao'
import MessageQueuesDao from '@/interfaces/common/MessageQueues.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import PaymentTransactionTypeDao from '@/interfaces/common/PaymentTransactionType.dao'
import AddressDao from '@/interfaces/order/Address.dao'
import ChannelAccountDao from '@/interfaces/order/ChannelAccount.dao'
import CostumerDao from '@/interfaces/order/Costumer.dao'
import { PaymentMethodDao } from '@/interfaces/order/PaymentMethod.dao'
import CountryDao from '@/interfaces/portfolio/Country.dao'
import CurrencyDao from '@/interfaces/portfolio/Currency.dao'
import MarketplaceDao from '@/interfaces/portfolio/Marketplace.dao'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import MarketplacesDao from '@/interfaces/common/Marketplaces.dao'
import AmazonAccountsDao from '@/interfaces/common/AmazonAccounts.dao'
import AmazonRegionsDao from '@/interfaces/common/AmazonRegions.dao'
import ChannelProfilesDao from '@/interfaces/common/ChannelProfiles.dao'
import PaymentMethodSalesChannelsDao from '@/interfaces/common/PaymentMethodSalesChannels.dao'
import PaymentMethodSalesChannelsDto from '@/interfaces/common/PaymentMethodSalesChannels.dto'
import CourierMappingsDao from '@/interfaces/common/CourierMappings.dao'
import CourierMappingsDto from '@/interfaces/common/CourierMappings.dto'
import ConfigurationsDao from '@/interfaces/common/Configurations.dao'
import ConfigurationsDto from '@/interfaces/common/Configurations.dto'
import { AxiosResponse } from 'axios'
import TaxClassesDao from '@/interfaces/common/TaxClasses.dao'
import SalesOrganisationsDao from '@/interfaces/common/SalesOrganisations.dao'
import ForexRatesDao from '@/interfaces/common/ForexRates.dao'

export default class CommonService extends ApiService {
    async getCountries(params?: IRequestParameters): Promise<[CountryDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CountryDao[], PageNumberPagination]>(
            'GET',
            '/countries',
            params,
            undefined,
            undefined,
            'getCountries',
        ).catch(() => null)
    }

    async getLedgerTransactionTypes(
        params?: IRequestParameters,
    ): Promise<[LedgerTransactionTypeDao[], PageNumberPagination] | null> {
        return this.request<undefined, [LedgerTransactionTypeDao[], PageNumberPagination]>(
            'GET',
            '/ledger-transaction-types',
            params,
            undefined,
            undefined,
            'getLedgerTransactionTypes',
        ).catch(() => null)
    }
    async getCurrencies(params?: IRequestParameters): Promise<[CurrencyDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CurrencyDao[], PageNumberPagination]>(
            'GET',
            '/currencies',
            params,
            undefined,
            undefined,
            'getCurrencies',
        ).catch(() => null)
    }
    async getChannelAccounts(params?: IRequestParameters): Promise<[ChannelAccountDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ChannelAccountDao[], PageNumberPagination]>(
            'GET',
            '/channel-accounts',
            params,
            undefined,
            undefined,
            'getChannelAccounts',
        ).catch(() => null)
    }
    async getPaymentMethods(params?: IRequestParameters): Promise<[PaymentMethodDao[], PageNumberPagination] | null> {
        return this.request<undefined, [PaymentMethodDao[], PageNumberPagination]>(
            'GET',
            '/payments/payment-methods',
            params,
            undefined,
            undefined,
            'getPaymentMethods',
        ).catch(() => null)
    }
    async getCustomers(params?: IRequestParameters): Promise<[CostumerDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CostumerDao[], PageNumberPagination]>(
            'GET',
            '/customers',
            params,
            undefined,
            undefined,
            'getCustomers',
        ).catch(() => null)
    }
    async getAddresses(params?: IRequestParameters): Promise<[AddressDao[], PageNumberPagination] | null> {
        return this.request<undefined, [AddressDao[], PageNumberPagination]>(
            'GET',
            '/payments/addresses',
            params,
            undefined,
            undefined,
            'getAddresses',
        ).catch(() => null)
    }
    async getMarketplacesAbba(params?: IRequestParameters): Promise<[MarketplaceDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MarketplaceDao[], PageNumberPagination]>(
            'GET',
            '/abba-marketplaces',
            params,
            undefined,
            undefined,
            'getMarketplacesAbba',
        ).catch(() => null)
    }
    async getMarketplaces(params?: IRequestParameters): Promise<[MarketplacesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MarketplacesDao[], PageNumberPagination]>(
            'GET',
            '/marketplaces',
            params,
            undefined,
            undefined,
            'getMarketplaces',
        ).catch(() => null)
    }
    async getAmazonAccounts(params?: IRequestParameters): Promise<[AmazonAccountsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [AmazonAccountsDao[], PageNumberPagination]>(
            'GET',
            '/amazon-accounts',
            params,
            undefined,
            undefined,
            'getAmazonAccounts',
        ).catch(() => null)
    }
    async getAmazonRegions(params?: IRequestParameters): Promise<[AmazonRegionsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [AmazonRegionsDao[], PageNumberPagination]>(
            'GET',
            '/amazon-regions',
            params,
            undefined,
            undefined,
            'getAmazonRegions',
        ).catch(() => null)
    }
    async getCurrenciesAbba(params?: IRequestParameters): Promise<[CurrencyDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CurrencyDao[], PageNumberPagination]>(
            'GET',
            '/abba-currencies',
            params,
            undefined,
            undefined,
            'getCurrenciesAbba',
        ).catch(() => null)
    }
    async getRoles(): Promise<string[] | null> {
        return this.request<undefined, string[]>(
            'GET',
            '/auth/roles',
            undefined,
            undefined,
            undefined,
            'getRoles',
        ).catch(() => null)
    }
    async getMessageQueue(id: number): Promise<MessageQueuesDao | null> {
        return this.request<undefined, MessageQueuesDao>(
            'GET',
            `/message-queues/${id}`,
            undefined,
            undefined,
            undefined,
            'getMessageQueue',
        ).catch(() => null)
    }
    async getMarketplaceProduct(id: number): Promise<MarketplaceProductDao | null> {
        return this.request<undefined, MarketplaceProductDao>(
            'GET',
            `/marketplace-products/${id}`,
            undefined,
            undefined,
            undefined,
            'getMarketplaceProduct',
        ).catch(() => null)
    }

    async getPaymentTransactionTypes(
        params?: IRequestParameters,
    ): Promise<[PaymentTransactionTypeDao[], PageNumberPagination] | null> {
        return this.request<undefined, [PaymentTransactionTypeDao[], PageNumberPagination]>(
            'GET',
            '/payment-types',
            params,
            undefined,
            undefined,
            'getPaymentTransactionTypes',
        ).catch(() => null)
    }

    async getChannelProfiles(
        params?: IRequestParameters,
    ): Promise<[ChannelProfilesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ChannelProfilesDao[], PageNumberPagination]>(
            'GET',
            '/channel-profiles',
            params,
            undefined,
            undefined,
            'getChannelProfiles',
        ).catch(() => null)
    }

    async getPaymentMethodSalesChannels(
        params?: IRequestParameters,
    ): Promise<[PaymentMethodSalesChannelsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [PaymentMethodSalesChannelsDao[], PageNumberPagination]>(
            'GET',
            '/payment-method-sales-channels',
            params,
            undefined,
            undefined,
            'getPaymentMethodSalesChannels',
        ).catch(() => null)
    }

    async getCourierMappings(
        params?: IRequestParameters,
    ): Promise<[CourierMappingsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CourierMappingsDao[], PageNumberPagination]>(
            'GET',
            '/courier-mappings',
            params,
            undefined,
            undefined,
            'getCourierMappings',
        ).catch(() => null)
    }

    async getConfigurations(params?: IRequestParameters): Promise<[ConfigurationsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ConfigurationsDao[], PageNumberPagination]>(
            'GET',
            '/configurations',
            params,
            undefined,
            undefined,
            'getConfigurations',
        ).catch(() => null)
    }

    async getTaxClasses(params?: IRequestParameters): Promise<[TaxClassesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [TaxClassesDao[], PageNumberPagination]>(
            'GET',
            '/tax-classes',
            params,
            undefined,
            undefined,
            'getTaxClasses',
        ).catch(() => null)
    }

    async createPaymentMethodSalesChannel(
        payload: PaymentMethodSalesChannelsDto,
    ): Promise<PaymentMethodSalesChannelsDao | null> {
        return this.request<PaymentMethodSalesChannelsDto, PaymentMethodSalesChannelsDao>(
            'POST',
            '/payment-method-sales-channels',
            undefined,
            payload,
            undefined,
            'createPaymentMethodSalesChannel',
        ).catch(() => null)
    }

    async createCourierMapping(payload: CourierMappingsDto): Promise<CourierMappingsDao | null> {
        return this.request<CourierMappingsDto, CourierMappingsDao>(
            'POST',
            '/courier-mappings',
            undefined,
            payload,
            undefined,
            'createCourierMapping',
        ).catch(() => null)
    }

    async createConfiguration(
        params: IRequestParameters,
        payload: ConfigurationsDto,
    ): Promise<ConfigurationsDao | null> {
        return this.request<ConfigurationsDto, ConfigurationsDao>(
            'POST',
            '/configurations',
            params,
            payload,
            undefined,
            'createConfiguration',
        ).catch(() => null)
    }

    async updateConfiguration(
        params: IRequestParameters,
        payload: ConfigurationsDto,
    ): Promise<ConfigurationsDao | null> {
        return this.request<ConfigurationsDto, ConfigurationsDao>(
            'PATCH',
            '/configurations',
            params,
            payload,
            undefined,
            'updateConfiguration',
        ).catch(() => null)
    }

    async deletePaymentMethodSalesChannel(id: string): Promise<any | null> {
        return this.request<undefined, any | null>(
            'DELETE',
            `/payment-method-sales-channels/${encodeURIComponent(id)}`,
            undefined,
            undefined,
            undefined,
            'deletePaymentMethodSalesChannel',
        ).catch(() => null)
    }

    async deleteCourierMapping(id: string): Promise<any | null> {
        return this.request<undefined, any | null>(
            'DELETE',
            `/courier-mappings/${encodeURIComponent(id)}`,
            undefined,
            undefined,
            undefined,
            'deleteCourierMapping',
        ).catch(() => null)
    }

    async deleteConfiguration(params: IRequestParameters, id: string): Promise<any | null> {
        return this.request<undefined, any | null>(
            'DELETE',
            `/configurations/${encodeURIComponent(id)}`,
            params,
            undefined,
            undefined,
            'deleteConfiguration',
        ).catch(() => null)
    }

    async getConfigurationsCategories(params?: IRequestParameters): Promise<string[] | null> {
        return this.request<undefined, string[]>(
            'GET',
            '/configurations/categories',
            params,
            undefined,
            undefined,
            'getConfigurationsCategories',
        ).catch(() => null)
    }

    async downloadImportTemplate(params: IRequestParameters): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            '/download-import-template',
            params,
            undefined,
            'blob',
            'downloadImportTemplate',
        ).catch(() => null)
    }

    async getSalesOrganisations(
        params?: IRequestParameters,
    ): Promise<[SalesOrganisationsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [SalesOrganisationsDao[], PageNumberPagination]>(
            'GET',
            '/sales-organisations',
            params,
            undefined,
            undefined,
            'getSalesOrganisations',
        ).catch(() => null)
    }

    async getForexRates(params?: IRequestParameters): Promise<[ForexRatesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ForexRatesDao[], PageNumberPagination]>(
            'GET',
            '/forex-rates',
            params,
            undefined,
            undefined,
            'getForexRates',
        ).catch(() => null)
    }

    async patchForexRate(payload: { Id: number; ExchangeRate: number }): Promise<ForexRatesDao | null> {
        return this.request<{ Id: number; ExchangeRate: number }, ForexRatesDao>(
            'POST',
            '/forex-rates',
            undefined,
            payload,
            undefined,
            'patchForexRate',
        ).catch(() => null)
    }
}
